import imgh2l from "./Images/imgh2l.jpg";
import gold from "./Images/gold.png";

export default function Qualidade() {
    return (
        <div className="divquality">
            <h2 className="h2lwritting">H2L Engenharia</h2>
            <div className="qualitywidth2">
                <img className="imgh2l" src={imgh2l}></img>

            </div>
            <div className="qualitywidth">

                <div className="boardquality">
                  
                    <h2 className="qualitytext">Projetar com <strong className="italic">Consciência,</strong> Executar com <strong className="italic">Excelência.</strong><hr className="hrquality"></hr></h2>
                    <h2 className="h2quality">Construir empreendimentos com foco na <strong className="sg">qualidade</strong> e na <strong className="sg">sustentabilidade</strong>, atendendo aos <strong className="sg">requisitos legais</strong> e regulamentares aplicáveis, satisfazendo as necessidades dos clientes e promovendo a melhoria contínua do sistema de <strong className="sg">gestão da qualidade</strong> e de seus processos.</h2>
                      <img className="imgicon2" src={gold} alt="Logo" />
                    <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/h2l-engenharia-ltda/?originalSubdomain=br">
                        <button className="btnquality">SAIBA MAIS</button>
                    </a>
                    
                </div>




            </div>


        </div>
    )
}